"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RulaSegmentAdapter = void 0;
const analytics_next_1 = require("@segment/analytics-next");
const events_1 = require("@pathccm/common-analytics/events");
const sessionReplay = __importStar(require("@amplitude/session-replay-browser"));
class RulaSegmentAdapter {
    apiKey;
    productArea;
    userId;
    userType;
    segment;
    static isSegmentInitialized = false;
    constructor({ apiKey, productArea, userId, userType, }) {
        this.apiKey = apiKey;
        this.productArea = productArea;
        this.userId = userId;
        this.userType = userType;
        // In a server environment (NextJS), we won't want to call the third-party init,
        // as it depends on client-side dependencies and would throw errors
        if (!RulaSegmentAdapter.isSegmentInitialized &&
            typeof window !== "undefined") {
            this.segment = analytics_next_1.AnalyticsBrowser.load({
                writeKey: this.apiKey,
            });
            this.init();
            RulaSegmentAdapter.isSegmentInitialized = true;
        }
    }
    // TODO: MAR-32 - implement serverUrl
    // https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/custom-proxy/#npm-instructions
    init() {
        this.identify({
            userId: this.userId,
            properties: { user_type: this.userType },
        });
        /* istanbul ignore next */
        this.segment.addSourceMiddleware(({ payload, next }) => {
            const event = payload.obj;
            if (event.type === "track") {
                const userType = event.properties?.extra?.user_type || this.userType;
                const productArea = event.properties?.extra?.product_area || this.productArea;
                const pagePath = typeof window !== "undefined" ? window.location.pathname : "";
                const pageUrl = typeof window !== "undefined" ? window.location.href : "";
                event.properties = {
                    ...event?.properties,
                    page_path: pagePath,
                    page_url: pageUrl,
                    product_area: productArea,
                    user_type: userType,
                };
            }
            next(payload);
        });
    }
    track(trackEvent) {
        const eventName = `${trackEvent.eventName.prefix}_${trackEvent.eventName.trigger}`;
        this.segment.track(eventName, trackEvent.properties, trackEvent.context);
    }
    async trackLink(links, trackEvent) {
        const eventName = `${trackEvent.eventName.prefix}_${trackEvent.eventName.trigger}`;
        await this.segment.trackLink(links, eventName, trackEvent.properties);
    }
    identify(identifyEvent) {
        this.segment.identify(identifyEvent.userId, identifyEvent.properties);
    }
    page(pageEvent) {
        this.segment.track(`${pageEvent.prefix}_${events_1.Trigger.PAGE_LOAD}`, {
            page: pageEvent.name,
            category: pageEvent.category,
            ...pageEvent.properties,
        });
    }
    // Adapted from: https://amplitude.com/docs/session-replay/session-replay-integration-with-segment
    /* istanbul ignore next */
    async enableAmplitudeSessionReplay(amplitudeApiKey, cookies) {
        if (typeof window === "undefined") {
            return;
        }
        const getStoredSessionId = () => {
            return cookies.get("amp_session_id") || 0;
        };
        const user = await this.segment.user();
        const storedSessionId = getStoredSessionId();
        await sessionReplay.init(amplitudeApiKey, {
            sessionId: storedSessionId,
            deviceId: user.anonymousId() || "0",
        }).promise;
        // Add middleware to check if the session id has changed,
        // and update the session replay instance
        this.segment.addSourceMiddleware(({ payload, next, integrations }) => {
            const storedSessionId = getStoredSessionId();
            setTimeout(() => {
                const nextSessionId = typeof payload.obj?.integrations?.["Actions Amplitude"] ===
                    "object" &&
                    "session_id" in payload.obj.integrations["Actions Amplitude"]
                    ? payload.obj.integrations["Actions Amplitude"].session_id
                    : 0;
                if (storedSessionId < nextSessionId) {
                    cookies.set("amp_session_id", nextSessionId.toString());
                    sessionReplay.setSessionId(nextSessionId);
                }
            }, 10);
            next(payload);
        });
        // Add middleware to always add session replay properties to track calls
        this.segment.addSourceMiddleware(({ payload, next, integrations }) => {
            const sessionReplayProperties = sessionReplay.getSessionReplayProperties();
            if (payload.type() === "track") {
                payload.obj.properties = {
                    ...payload.obj.properties,
                    ...sessionReplayProperties,
                };
            }
            next(payload);
        });
    }
}
exports.RulaSegmentAdapter = RulaSegmentAdapter;
//# sourceMappingURL=rula-segment-adapter.js.map